import { atom } from "@mongez/react-atom";
import type { Cart } from "core/cart";
import { LoadingState } from "core/shared/types";

type CartAtomState = {
  cart: Cart;
  state: LoadingState;
  totalItems: number;
};

export const cartAtom: any = atom<CartAtomState>({
  key: "cart",
  default: {},
});
